import { useAuthStore } from "@/state/pinia";
import AppSettings from "@/AppSettings.json"
export default [
  {
    path: AppSettings.appPath + "/:vin?",
    name: "start",
    props: true,
    meta: { title: "menu_items.public_start.text", authRequired: false },
    component: () => import("../views/public/default")
  },
  {
    path: AppSettings.appPath + "/testdrive/:agency/:make",
    name: "testdrive",
    props: true,
    meta: { title: "menu_items.public_testdrive.text", authRequired: false },
    component: () => import("../views/public/test-drive")
  },
  {
    path: AppSettings.appPath + "/appointments/:vin?",
    name: "appointments",
    props: true,
    meta: { title: "menu_items.appointments.text", authRequired: false },
    component: () => import("../views/public/appointments")
  },
  {
    path: AppSettings.appPath + "/admin",
    name: "dashboard",
    meta: { title: "menu_items.dashboard.text", authRequired: true },
    component: () => import("../views/dashboards/default")
  },
  {
    path: AppSettings.appPath + "/admin/agencies",
    name: "agencies",
    meta: { title: "menu_items.agencies.text", authRequired: true },
    component: () => import("../views/agencies/agenciesList")
  },
  {
    path: AppSettings.appPath + "/admin/agencies/edit/:id",
    name: "agencies_edit",
    props: true,
    meta: { title: "menu_items.agencies.edit.text", authRequired: true },
    component: () => import("../views/agencies/agenciesEdit")
  },
  {
    path: AppSettings.appPath + "/admin/agencies/teams/:agency",
    props: true,
    name: "agency_teams",
    meta: { title: "menu_items.teams.text", authRequired: true },
    component: () => import("../views/teams/teamsList")
  },
  {
    path: AppSettings.appPath + "/admin/agencies/teams/:agency/resources/:team",
    props: true,
    name: "team_resources",
    meta: { title: "menu_items.resources.text", authRequired: true },
    component: () => import("../views/resources/resourcesList")
  },
  {
    path: AppSettings.appPath + "/admin/agencies/teams/:agency/edit/:id",
    props: true,
    name: "team_edit",
    meta: { title: "menu_items.teams.text", authRequired: true },
    component: () => import("../views/teams/teamsEdit.vue")
  },
  {
    path: AppSettings.appPath + "/admin/bookings",
    name: "bookings",
    meta: { title: "menu_items.bookings.text", authRequired: true },
    component: () => import("../views/bookings/bookingsList.vue")
  },
  {
    path: AppSettings.appPath + "/admin/bookings/edit/:id",
    name: "bookings_edit",
    props: true,
    meta: { title: "menu_items.bookings.edit.text", authRequired: true },
    component: () => import("../views/bookings/bookingsEdit.vue")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login"),
    meta: {
      title: "menu_items.login.text",
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        if (auth.loggedIn) {
          next({ name: "dashboard" });
        } else {
          next();
        }
      }
    }
  }
];
